import React, { useContext, useState } from 'react';
import { DeviceContext, deviceType } from '@providers';

import useScroll from '@src/hooks/useScroll';
import useIsComDomain from '@src/hooks/useIsComDomain';

import TopButton from '@src/componentsNew/Buttons/TopButton/TopButton';
import DesktopTagProductListPage from './DesktopTagProductListPage';
import MobileTagProductListPage from './MobileTagProductListPage';

import { productsVariables } from '@components/ProductPage/ProductList/__generated__/products';
import { StockAvailability, ProductOrderField, OrderDirection } from '__generated__/globalTypes';

import { getGraphqlIdFromDBId } from '@utils';
import { DESKTOP_PRODUCT_LIST_REQUEST_COUNT, MOBILE_PRODUCT_LIST_REQUEST_COUNT } from '@src/utils/constants';

const TagPage = ({ match }) => {
  const { isMobile } = useContext<deviceType>(DeviceContext);
  const isComDomain = useIsComDomain();
  const { isScrolled, scrollTop } = useScroll();
  const tagId = getGraphqlIdFromDBId(match.params.id, 'Tag');

  const initialVariables: productsVariables = {
    tag: tagId,
    stockAvailability: StockAvailability.IN_STOCK,
    sortBy: {
      field: ProductOrderField.POPULARITY,
      direction: OrderDirection.DESC,
    },
    first: isMobile ? MOBILE_PRODUCT_LIST_REQUEST_COUNT : DESKTOP_PRODUCT_LIST_REQUEST_COUNT,
    ...(isComDomain && { isMgs: true }),
  };

  const [variables, setVariables] = useState<productsVariables>(initialVariables);

  return (
    <>
      {isMobile ? (
        <MobileTagProductListPage
          initialVariables={initialVariables}
          variables={variables}
          setVariables={setVariables}
        />
      ) : (
        <DesktopTagProductListPage
          initialVariables={initialVariables}
          variables={variables}
          setVariables={setVariables}
        />
      )}
      {isScrolled && <TopButton isMobile={isMobile} onClick={scrollTop} />}
    </>
  );
};

export default TagPage;
